module.exports = __webpack_public_path__ + "img/logo.3da50ab8.png";